import { FC } from "react";
import { Dialog, DialogContent, DialogFooter } from "@src/lib/ui/Dialog";
import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";
import { pluralize } from "@src/lib/utils/strings";
import TriangleWarningOutlineIcon from "@src/lib/icons/18px/triangle-warning-outline";

type Props = {
  selectedItemsCount: number;
  onConfirm: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const UpdateAccessMultiSelectConfirmationDialog: FC<Props> = ({
  selectedItemsCount,
  onConfirm,
  open,
  onOpenChange,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-6 pb-8">
        <div className="flex flex-col">
          <div className="flex size-14 items-center justify-center rounded-lg bg-yellow-3">
            <TriangleWarningOutlineIcon className="size-8" />
          </div>
          <div className="mt-8">
            <Text variant="body-title" multiline>
              Are you sure you want to update access for{" "}
              {selectedItemsCount > 1 ? "these" : "this"} {selectedItemsCount}{" "}
              {pluralize("item", selectedItemsCount)}?
            </Text>
          </div>
          <div className="mt-2">
            <Text variant="compact-title" className="text-gray-6" multiline>
              User access will be updated immediately. Items must be published
              for access to be applied.
            </Text>
          </div>
        </div>
        <DialogFooter className="mt-10">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateAccessMultiSelectConfirmationDialog;
